<template>
    <section>
		
        <!-- 查询栏 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;"  @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.shopname" @keyup.enter.native="getShop" placeholder="门店名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getShop"  icon="el-icon-search">查询门店信息</el-button>
				</el-form-item>
			</el-form>
		</el-col>
        	<!--列表-->
		<el-table :data="shoplist" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="Name" label="门店名称 " width="150" sortable>
			</el-table-column>
			<el-table-column prop="LinkMan" label="联系人" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Mobile" label="手机号码" width="180" sortable>
 			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>  
			<el-table-column  label="开通一卡通" width="140" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].OneCardSystemState==1?true:false" active-color="#13ce66" inactive-color="#ff4949" @change="ChangeOneCardSystemState(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>			
			<el-table-column  label="会员版本" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				     <el-dropdown trigger="click">
                      <el-button type="success"  v-if="scope.row.SkinVersion=='VersionStyle-VIP'||scope.row.SkinVersion==null" size="small" >标准会员</el-button>
					   <el-button type="warning"   v-else-if="scope.row.SkinVersion=='VersionStyle-Free'" size="small" >收费会员</el-button>
                     <el-dropdown-menu slot="dropdown" >
                           <el-dropdown-item class="clearfix"  v-if="scope.row.SkinVersion=='VersionStyle-Free'" @click.native="ChangeVersion(scope.row)">
                            标准会员
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" v-if="scope.row.SkinVersion=='VersionStyle-VIP'||scope.row.SkinVersion==null" @click.native="ChangeVersion(scope.row)">
                            收费会员
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>				
					 	 </template>
			</el-table-column>				
			<el-table-column  label="赛事报名" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].CompetitionState==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="ChangeCompetition(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>				
			<el-table-column  label="证书开关" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].CertificateState==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="ChangeCertificate(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>				
			<el-table-column  label="评价开关" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].EvaluateState==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="ChangeEvaluate(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	                         
			<el-table-column  label="闸柜模式" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				     <el-dropdown trigger="click">
                      <el-button type="danger"  v-if="scope.row.MachineState==0||scope.row.MachineState==null" size="small" >不使用设备</el-button>
                      <el-button type="success"  v-else-if="scope.row.MachineState==1" size="small" >全智能</el-button>
					   <el-button type="warning"   v-else-if="scope.row.MachineState==2" size="small" >半智能</el-button>
                     <el-dropdown-menu slot="dropdown" >
                         <el-dropdown-item class="clearfix" @click.native="ChangeMachineState(scope.row,0)" >
                            不使用设备
                          </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeMachineState(scope.row,2)">
                            半智能
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" @click.native="ChangeMachineState(scope.row,1)">
                            全智能
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>				
					 	 </template>
			</el-table-column>
			<el-table-column  label="进出模式" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				     <el-dropdown trigger="click">
                      <el-button type="success"  v-if="scope.row.Pattern==0||scope.row.Pattern==null" size="small" >一进一出</el-button>
					   <el-button type="warning"   v-else-if="scope.row.Pattern==1" size="small" >多进多出</el-button>
                     <el-dropdown-menu slot="dropdown" >
                           <el-dropdown-item class="clearfix"  v-if="scope.row.Pattern==1" @click.native="ChangePatternState(scope.row)">
                            一进一出
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" v-if="scope.row.Pattern==0||scope.row.Pattern==null" @click.native="ChangePatternState(scope.row)">
                            多进多出
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>				
					 	 </template>
			</el-table-column>						
			<el-table-column  label="微信上线" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="shoplist[scope.$index].Id"   v-model="shoplist[scope.$index].State==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row,shoplist[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	
			<el-table-column prop="MsgPower" label="通知方式" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
				     <el-dropdown trigger="click">

                      <el-button type="info" v-if="scope.row.MsgPower==0||scope.row.MsgPower==null" size="small" >短信通知</el-button>
                      <el-button type="success"  v-else-if="scope.row.MsgPower==2" size="small" >微信通知</el-button>
					   <el-button type="warning"   v-else-if="scope.row.MsgPower==3" size="small" >混合通知</el-button>
                      <el-button type="danger"   v-else-if="scope.row.MsgPower==1" size="small" >停用通知</el-button>

                     <el-dropdown-menu slot="dropdown" >
                         <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,0)" >
                            短信通知
                          </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,2)">
                            微信通知
                         </el-dropdown-item>
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,3)">
                            混合通知
                         </el-dropdown-item>							 
                           <el-dropdown-item class="clearfix" @click.native="ChangeState(scope.row,1)">
                            停用通知
                         </el-dropdown-item>	
					 					 
                     </el-dropdown-menu>
                     </el-dropdown>	
                  </template>
			</el-table-column>			
		</el-table>
        <!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
    </section>
</template>
<script>
	import {ChangeShopOneCardSystemState, ChangeVersionStyle,ChangeShopCompetitionState,ChangeCertificateState, ChangePattern,MachineStateSet,MsgPowerSet,getShopList,ShopOnlineSet,ChangeEvaluateState } from '../../api/api';
export default {
    data(){
        return{
			   editorModel:false,
            filters: {
					Name: ''
				},
				  //充值记录相关
				  TitleName:'',
				  dialogTableVisible:false,
				  ShopRechargeData:[],
				  logCount:0,
				  ShopId:0,
				  logLoading:false,
				  logPage:0,
				  //


				// 短信充值相关
				RechargeFormVisible:false,
				RechargeForm:{
					Id: 0,
					Count:1,
					Money:0,
					UnitPrice:0.1
				},
                 RechargeFormRules:{
					Count: [
						{ required: true, message: '请输入短信充值数量'},
                        { type: 'number', message: '必须为数字值'}
					],
					Money: [
						{ required: true, message: '请输入短信充值金额'},
                        { type: 'number', message: '必须为数字值'}
					],
					UnitPrice: [
						{ required: true, message: '请输入短信充值单价'},
                        { type: 'number', message: '必须为数字值'}
					],
	
				 },
				 RechargeLoading:false,
				//  --
                shoplist: [],
				total: 0,
				page: 0,
                listLoading: false,
                sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Name: [
						{ required: true, message: '请输入门店名称', trigger: 'blur' }
					],
					SMSSign:[
						{ required: true, message: '请输入短信签名', trigger: 'blur' }	
					],
					UnitPrice:[{ required: true, message: '请输入短信单价'},
                        { type: 'number', message: '必须为数字值'}]				
				},
				//编辑界面数据
				editForm: {
					Id: 0,
					Name: '',
				    SMSSign:'',
                    LinkMan:'',
					Mobile:'',
                    Tel:'',
					Address:'',
					Remark:'',
					UnitPrice:0					
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入门店名称', trigger: 'blur' }
					],
					SMSSign:[
						{ required: true, message: '请输入短信签名', trigger: 'blur' }	
					]					
				},
				//新增界面数据
				addForm: {
				    Name: '',
				    SMSSign:'SMSSign',
                    LinkMan:'',
					Mobile:'',
                    Tel:'',
					Address:'',
					Remark:''					
				}
        }
    },
    methods:{
		ChangeVersion(row)
		  {
			  	let para={
						id:row.Id
				}						  
              ChangeVersionStyle(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.SkinVersion=res.data.Data;
									console.log(res);
									console.log(row.SkinVersion);
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
							      	});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});			  

		  },

		ChangePatternState(row)
		  {
			  	let para={
						id:row.Id
				}						  
              ChangePattern(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.Pattern=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});			  

		  },
		ChangeMachineState(row,code)
		{
			  	let para={
						id:row.Id,	
						stateCode:code			
				}						  
              MachineStateSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.MachineState=code;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});			  
		},
		ChangeOneCardSystemState(row,index){
				let para={
                        id:index,	                        
				}
              ChangeShopOneCardSystemState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.OneCardSystemState=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});	
		},
		ChangeCompetition(row,index){			
				let para={
                        id:index,	                        
				}
              ChangeShopCompetitionState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.CompetitionState=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});						
		},
		ChangeCertificate(row,index){
			

				let para={
                        id:index,	                        
				}
              ChangeCertificateState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.CertificateState=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});			
		},
      ChangeEvaluate(row,index)
			{
				let para={
                        id:index,	
                        stateCode:0,			
				}
              ChangeEvaluateState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.EvaluateState=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},
		Change(row,index)
			{
				let para={
						id:index,				
				}
              ShopOnlineSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.State=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},
			ChangeState(row,index)
			{
				let para={
						id:row.Id,
						stateCode:index				
				}
              MsgPowerSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.MsgPower=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});				

			},


         Count(){
			 this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;
		 },
		 UnitPrice()
		 {
			 this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;

		 },
		closeing()
		{
            this. getShop();
		},
          	handleCurrentChange(val) {
                this.page = val;
                //
				this.getShop();
			},
			CurrentChange(val)
			{
                this.logPage = val;
                //
				this.rechargeLogData();
			},
            	//获取门店列表
			 getShop() {
				let Params = {
					PageIndex: this.page-1,
					
					PageSize:10,
					Name:this.filters.shopname
				};
				this.listLoading = true;
				getShopList(Params).then((res) => {
					this.total = res.data.TotleCount;
					this.shoplist = res.data.Data;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },
            	//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
				// console.log(this.editForm);
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
				     Name: '',
				      SMSSign:'SMSSign',
                    LinkMan:'',
					Mobile:'',
                    Tel:'',
					Address:'',
					Remark:''									
				};
			},


			selsChange: function (sels) {
				this.sels = sels;
			},
    },
    mounted() {
			this. getShop();
			
		}
}
</script>




// WEBPACK FOOTER //
// ShopControl.vue?2381432b